
































































































































































































































































































































































































import { Component, Watch, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
import UserDetailBase from "./UserDetailBase";
import TreeViewModal from "../../../Components/ComponentsBase/BaseTLModalDialogTreeView.vue";


import Chart from 'chart.js';

@Component
export default class UserDetail extends UserDetailBase {

    options = [
        { value: null, text: 'Please select an option' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option', disabled: true },
        {
            label: 'Grouped options',
            options: [
                { value: { C: '3PO' }, text: 'Option with object value' },
                { value: { R: '2D2' }, text: 'Another option with object value' }
            ]
        }
    ]

    dynamicID() {
        var id = 'dynamicID-' + (Math.floor(Math.random() * Date.now()));
        return id;
    }
    created() {
        super.initializeRights('COR_User_Create', 'COR_User_Delete', 'COR_User_Read', 'COR_User_Update');
        super.setMainDescription('user.new', 'user.detail');
        this.idUser = this.objectIdFromQuery;
        this.createdBase();
    }

    disableAddButton() {
        return this.formData.id == 0;
    }
  
    preventRefresh(event: any) {
        if (this.$store.state.askBeforeCancelEditing === true && ((this.formIsInEditMode && this.dataWasChanged()) || this.mainDataChangedSub)) {
            event.preventDefault(); event.returnValue = "";
        }
    }
  
    beforeMount() {
        window.addEventListener("beforeunload", this.preventRefresh);
    }

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.preventRefresh);
        this.$store.commit("formIsInEditMode", false);
        this.$store.commit("mainDataChanged", false);
    }

    showBackButtonAllow() {
        return this.showBackButton && RightHelper.currentUserHasRight('COR_User_Read');
    }

    showAddRole() {
        return RightHelper.currentUserHasRight('COR_User_Update');
    }

    showButtonPasswordChange() {
        return this.styleFormNew == false && this.showPasswordButton && this.isChangePassword == false && this.formIsInEditMode == false && this.authPassword == true;// && (this.profile || RightHelper.currentUserHasRight('COR_User_Update'));
    }

    googleLogin(): void {
        this.googleLoginBase();
    }

    showSaveButtonMain() {
        
        return this.showSaveButton || this.showSaveAll();
    }

    showSaveAll(): boolean {
        //return !this.roleNotChangeBase() && !this.formIsInEditMode;
        return !this.roleNotChangeBase();
    }

    private roleNotChanged(): boolean {
     
        this.mainDataChangedSub = !this.roleNotChangeBase();
        return this.roleNotChangeBase() && this.canUpdate;
    }
  
    private goBackRoles(): void {
        this.mainDataChangedSub = false;
        this.goBackRolesBase();
    }

    private saveChangeRole(): void {
        this.saveChangeRoleBase();
    }

    mounted() {
        super.mounted();
        this.loadDataRole(this.formData.id, false);
        //TODO jen docasne nez se to nekde nasadi
        // this.renderChart();
    };

    private deleteRole(item: any): void {
        this.deleteRoleBase(item);
    }

    private addNewRole(): void {
        this.addNewRoleBase();
    }

    private async settingRole(item: any) {
        var result = await this.settingRoleBase(item);
        (this.$refs.userRoleModal as TreeViewModal).init(result, this.idUser, this.idRole);
    }

    private changeViewTreeData(changeDataItems: any) {
        this.changeDataBase(changeDataItems);
    }

    selectedRoleItems(selected: any): void {
        this.selectedRoleItemsBase(selected);
    }

    isCorrectLogin(value: any) {
        this.isCorrectLoginBase(value);
    }

    isCorrectPass(value: any) {
        this.isCorrectPassBase(value);
    }

    isCorrectPassAgain(value: any) {
        this.isCorrectPassAgainBase(value);
    }

    isCorrectPassOld(value: any) {
        this.isCorrectPassOldBase(value);
    }

    isCorrectPassNew(value: any) {
        this.isCorrectPassNewBse(value);
    }

    isCorrectPassNew2(value: any) {
        this.isCorrectPassNewBase2(value);
    }

    isCorrectEmail(value: any) {
        this.isCorrectEmailBase(value);
    }
    
    //potřeba refresh při změně jazyka, když je to modal oknech
    //@ts-ignore
    @Watch('$i18n.locale')
    changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
        this.changeFieldsAfterChangeLanguageBase(value, oldValue);
    }


    //TODO pryc az se to nekde nasadi GRAF
    //renderChart() {
    //    //@ts-ignore
    //    const ctx = this.$refs.chartCanvas.getContext('2d');
    //    new Chart(ctx, {
    //        type: 'line',
    //        data: {
    //            labels: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00'],
    //            datasets: [
    //                {
    //                    label: 'Teplota CPU 1',
    //                    data: [32, 55, 66, 51, 45, 35],
    //                    backgroundColor: 'rgba(255, 180, 132, 1)',
    //                    borderColor: 'rgba(255, 180, 132, 1)',
    //                    borderWidth: 2,
    //                    fill: false
    //                },
    //                {
    //                    label: 'Teplota CPU 2',
    //                    data: [63, 65, 76, 41, 35, 66],
    //                    backgroundColor: 'rgba(255, 0, 132, 1)',
    //                    borderColor: 'rgba(255, 0, 132, 1)',
    //                    borderWidth: 2,
    //                    fill: false
    //                }
    //                ,
    //                {
    //                    label: 'Teplota CPU 3',
    //                    data: [13, 25, 23, 39, 50, 59],
    //                    backgroundColor: 'rgba(0, 0, 132, 1)',
    //                    borderColor: 'rgba(0, 0, 132, 1)',
    //                    borderWidth: 2,
    //                    fill: false
    //                }
    //            ]
    //        }
    //    });

        //@ts-ignore
        //const ctxBar = this.$refs.chartCanvasBar.getContext('2d');
    //    new Chart(ctxBar, {
    //        type: 'bar',
    //        data: {
    //            labels: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00'],
    //            datasets: [
    //                {
    //                    label: 'Teplota CPU',
    //                    data: [32, 55, 66, 51, 45, 35],
    //                    backgroundColor: 'rgba(255, 180, 132, 0.2)',
    //                    borderWidth: 2
    //                }
    //            ]
    //        }
    //    });
    //}

}
